@playlist-padding-top: 10px;
@playlist-width: 100%;
@playlist-height: 120px - @playlist-padding-top;
@playlist-position-bottom: -@playlist-height - @playlist-padding-top;

// Applied to overwrite some of the default Brightcove styles
.brighcoveOverrideStyles() {
  .video-js {
    width: 100%;
    height: 100%;
    border-radius: 40px;
    .vjs-play-progress:before {
      z-index: 0;
    }
  }
  .vjs-big-play-button {
    display: none;
  }
}

.asVideoLayer() {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.igws-video {
  .brighcoveOverrideStyles();
  position: relative;
  aspect-ratio: 16/9;
  font-family: 'Matter SQ';
  border-radius: 40px;

  &__brightcove-player {
    width: 100%;
    height: 100%;
    border-radius: 40px;
  }

  &__brightcove-player:has(.igws-video__playlist-wrapper.show) {
    margin-bottom: @playlist-height;
  }

  &__overlay {
    display: none;
  }

  &__overlay.active {
    .asVideoLayer();
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-image: url(https://a.c-dn.net/c/etc.clientlibs/settings/wcm/designs/onedomain/1670245825000/clientlibs_resources/resources/images/bg-video.jpg);
  }

  &__overlay-text {
    color: #333;
    font-size: 22px;

    &--beforelive {
      font-size: 16px;
      font-weight: 700;
    }
  }

  &__cta-button {
    display: inline-block;
    text-decoration: none;
    margin: 16px 5px 0;
    padding: 10px 14px;
    width: 120px;
    text-align: center;
    font-weight: 500;
    font-size: 16px;

    &--primary {
      background-color: #40a421;
      box-shadow: 2px 2px 3px 0 #666;
      color: white;
    }
    &--secondary {
      color: #333;
      background-color: transparent;
      border: 1px solid #333;
      box-shadow: 2px 2px 3px 0 #46484f;
    }
  }

  &__replay-video {
    text-decoration: none;
    background-color: #fff;
    background-position: -5px -2px;
    background-image: url(https://a.c-dn.net/c/etc.clientlibs/settings/wcm/designs/onedomain/1670245825000/clientlibs_resources/resources/images/sprites/small-icons.png);
    background-repeat: no-repeat;
    color: #46484f;
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    font-weight: 400;
    padding: 10px 20px 10px 45px;
    cursor: pointer;
  }

  &__poster-img-slot {
    .asVideoLayer();
    img {
      width: 100%;
      height: 100%;
      border-radius: 40px;
    }

    &.hide {
      display: none;
    }

    &:after {
      .asVideoLayer();
      content: '';
      display: block;
      background-image: url(https://a.c-dn.net/c/etc.clientlibs/settings/wcm/designs/onedomain/1670245825000/clientlibs_resources/resources/images/video-play.png);
      background-repeat: no-repeat;
      background-position: center center;
      background-color: rgba(0, 0, 0, 0.2);
      cursor: pointer;
      border-radius: 40px;
    }
  }

  &__playlist-wrapper {
    display: none;
  }

  &__playlist-wrapper.show {
    display: block;
    position: absolute;
    left: 0;
    bottom: @playlist-position-bottom;
    width: @playlist-width;
    height: @playlist-height;
    padding-top: @playlist-padding-top;
    overflow-y: hidden;
    background-color: #1a1a1a;
    .vjs-playlist {
      height: @playlist-height;
      white-space: nowrap;
      margin: 0;
      .vjs-playlist-item {
        margin: 0 10px 0 10px;
        height: auto;
      }
      cite {
        font-size: 13px;
        line-height: 20px;
        text-overflow: initial;
        white-space: normal;
        height: 60px;
      }
    }
    .vjs-playlist-item {
      width: 121px;
    }
    .vjs-playlist-thumbnail {
      float: none;
      margin: 0 0 10px;
    }
  }
}

.igws-video-transcript {
  a {
    display: inline-block;
    margin: 1em 0 0;
    color: @ig-blue;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    text-decoration: none;
  }

  a + div {
    display: none;
  }

  a + div.show {
    margin-top: 10px;
    display: block;
  }
}
